import {
  BrandAndMarketListItem,
  CodeAndLabel,
  GlobalFilterListOrderValue,
  GuidIdAndLabel,
  GuidIdCodeAndLabel,
  Int32IdAndLabel,
  StationOrLocationItem,
} from '../../../integrated-client/models';
import { DEFAULT_PAGE_SIZE, DEFAULT_TOTAL_ITEMS } from '../../../utils/Constants';

export interface IFiltersData {
  brandAndMarket?: BrandAndMarketListItem | null;
  distributionChannel?: Int32IdAndLabel | null;
  agency?: GuidIdCodeAndLabel | null;
  agencyOnly?: boolean | null;
  destination?: StationOrLocationItem | null;
  description?: string | null;
  relevance?: number | null;
  fareType?: CodeAndLabel | null;
  carrier?: GuidIdCodeAndLabel | null;
  supplier?: GuidIdAndLabel | null;
  allow?: any;
  showDeleted?: boolean;
  showDisabled?: boolean;
  orderValue?: GlobalFilterListOrderValue;
  orderByDescending?: boolean;
  offset: number;
  limit: number;
  total: number;
  currentPage: number;
}

export class FiltersData implements IFiltersData {
  brandAndMarket?: BrandAndMarketListItem | null;
  distributionChannel?: Int32IdAndLabel | null;
  agency?: GuidIdCodeAndLabel | null;
  agencyOnly?: boolean | null;
  destination?: StationOrLocationItem | null;
  description?: string | null;
  relevance?: number | null;
  fareType?: CodeAndLabel | null;
  carrier?: GuidIdCodeAndLabel | null;
  supplier?: GuidIdAndLabel | null;
  allow?: any;
  showDeleted?: boolean;
  showDisabled?: boolean;
  orderValue?: GlobalFilterListOrderValue;
  orderByDescending?: boolean;
  offset: number;
  limit: number;
  total: number;
  currentPage: number;

  constructor() {
    this.brandAndMarket = null;
    this.distributionChannel = null;
    this.agency = null;
    this.agencyOnly = null;
    this.destination = null;
    this.description = null;
    this.relevance = null;
    this.fareType = null;
    this.carrier = null;
    this.supplier = null;
    this.showDeleted = false;
    this.showDisabled = false;
    this.offset = 0;
    this.limit = DEFAULT_PAGE_SIZE;
    this.total = DEFAULT_TOTAL_ITEMS;
    this.currentPage = 1;
  }
}
